import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription
} from '@/components/ui/dialog';

// Inline "+ Add new address" dialog — lets dispatchers create a new customer
// address directly from the edit-load sheet (no trip to Master Tables).
// Fully controlled by the parent (state + save handler come in as props).
export const AddNewAddressDialog = ({
  open,
  onOpenChange,
  selectedCustomer,
  newAddress,
  setNewAddress,
  onSave,
  saving,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-slate-900 border-slate-800 text-slate-100 sm:max-w-lg" data-testid="add-address-dialog">
      <DialogHeader>
        <DialogTitle>Add new address for {selectedCustomer?.name}</DialogTitle>
        <DialogDescription className="text-slate-400">
          This address will be saved on the customer and selected on this load.
        </DialogDescription>
      </DialogHeader>
      <div className="grid grid-cols-2 gap-3 py-2">
        <div className="col-span-2 space-y-1.5">
          <Label className="text-slate-300 text-xs">Label (e.g. Warehouse #2)</Label>
          <Input
            value={newAddress.label}
            onChange={(e) => setNewAddress(p => ({ ...p, label: e.target.value }))}
            className="bg-slate-950 border-slate-800"
          />
        </div>
        <div className="col-span-2 space-y-1.5">
          <Label className="text-slate-300 text-xs">Street address *</Label>
          <Input
            value={newAddress.address}
            onChange={(e) => setNewAddress(p => ({ ...p, address: e.target.value }))}
            className="bg-slate-950 border-slate-800"
            data-testid="add-address-street-input"
          />
        </div>
        <div className="space-y-1.5">
          <Label className="text-slate-300 text-xs">City</Label>
          <Input
            value={newAddress.city}
            onChange={(e) => setNewAddress(p => ({ ...p, city: e.target.value }))}
            className="bg-slate-950 border-slate-800"
          />
        </div>
        <div className="space-y-1.5">
          <Label className="text-slate-300 text-xs">State</Label>
          <Input
            value={newAddress.state}
            onChange={(e) => setNewAddress(p => ({ ...p, state: e.target.value }))}
            className="bg-slate-950 border-slate-800"
          />
        </div>
        <div className="space-y-1.5">
          <Label className="text-slate-300 text-xs">ZIP</Label>
          <Input
            value={newAddress.zip_code}
            onChange={(e) => setNewAddress(p => ({ ...p, zip_code: e.target.value }))}
            className="bg-slate-950 border-slate-800"
          />
        </div>
        <div className="space-y-1.5">
          <Label className="text-slate-300 text-xs">Contact name</Label>
          <Input
            value={newAddress.contact_name}
            onChange={(e) => setNewAddress(p => ({ ...p, contact_name: e.target.value }))}
            className="bg-slate-950 border-slate-800"
          />
        </div>
        <div className="col-span-2 space-y-1.5">
          <Label className="text-slate-300 text-xs">Contact phone</Label>
          <Input
            value={newAddress.contact_phone}
            onChange={(e) => setNewAddress(p => ({ ...p, contact_phone: e.target.value }))}
            className="bg-slate-950 border-slate-800"
          />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)} className="border-slate-700">Cancel</Button>
        <Button
          onClick={onSave}
          disabled={saving || !newAddress.address}
          className="bg-sky-600 hover:bg-sky-500"
          data-testid="add-address-save-btn"
        >
          {saving ? 'Saving…' : 'Save & select'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
